<script setup>
/**
 * SignInPage — sign-in form rendered by Vue, submitted as a native POST.
 */
import { shallowRef } from "vue";

const { csrfParam, csrfToken, formAction } = defineProps({
  csrfParam: { required: true, type: String },
  csrfToken: { required: true, type: String },
  formAction: { required: true, type: String }
});

const username = shallowRef("");
const password = shallowRef("");
</script>

<template>
  <form :action="formAction" method="post">
    <input type="hidden" :name="csrfParam" :value="csrfToken" />

    <div class="mb-4">
      <label for="username" class="mb-1.5 block text-sm font-medium text-[var(--gl-text-color-default)]">
        Username
      </label>
      <input
        id="username"
        v-model="username"
        name="username"
        type="text"
        placeholder="Username"
        autocomplete="username"
        class="w-full rounded-[var(--gl-control-border-radius)] border-none bg-[var(--gl-control-background-color-default)] px-3 py-2 text-sm text-[var(--gl-text-color-default)] shadow-[inset_0_0_0_1px_var(--gl-control-border-color-default)] placeholder:text-[var(--gl-control-placeholder-color)] hover:shadow-[inset_0_0_0_1px_var(--gl-control-border-color-hover)] focus:shadow-[inset_0_0_0_1px_var(--gl-control-border-color-focus)] focus:outline-none"
      />
    </div>

    <div class="mb-4">
      <label for="password" class="mb-1.5 block text-sm font-medium text-[var(--gl-text-color-default)]">
        Password
      </label>
      <input
        id="password"
        v-model="password"
        name="password"
        type="password"
        placeholder="Password"
        autocomplete="current-password"
        class="w-full rounded-[var(--gl-control-border-radius)] border-none bg-[var(--gl-control-background-color-default)] px-3 py-2 text-sm text-[var(--gl-text-color-default)] shadow-[inset_0_0_0_1px_var(--gl-control-border-color-default)] placeholder:text-[var(--gl-control-placeholder-color)] hover:shadow-[inset_0_0_0_1px_var(--gl-control-border-color-hover)] focus:shadow-[inset_0_0_0_1px_var(--gl-control-border-color-focus)] focus:outline-none"
      />
    </div>

    <div class="mb-6 flex items-center gap-2">
      <input
        id="remember_me"
        name="remember_me"
        type="checkbox"
        value="1"
        class="h-4 w-4 cursor-pointer rounded border-[var(--gl-border-color-default)] accent-[var(--gl-color-blue-500)]"
      />
      <label for="remember_me" class="cursor-pointer text-sm text-[var(--gl-text-color-default)]"> Remember me </label>
    </div>

    <button
      id="sign_in"
      type="submit"
      class="w-full cursor-pointer rounded-[var(--gl-action-border-radius)] bg-[var(--gl-button-confirm-primary-background-color-default)] px-4 py-2 text-sm font-medium text-[var(--gl-button-confirm-primary-foreground-color-default)] hover:bg-[var(--gl-button-confirm-primary-background-color-hover)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--gl-focus-ring-outer-color)]"
    >
      Sign in
    </button>
  </form>
</template>
